export default __webpack_public_path__ + "static/media/1 Light Rain - 30s sample.f56a5a03.mp3";